import { render, staticRenderFns } from "./chatIcon.vue?vue&type=template&id=4ab46110"
import script from "./chatIcon.vue?vue&type=script&lang=js"
export * from "./chatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports